import loadable from "@loadable/component";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateDeliveryComponent = loadable(
  () => import("../../components/Delivery/CreateDelivery")
);
const CreateDelivery = () => {
  const navigate = useNavigate();
  const [openAddVehiclePopup, setOpenAddVehiclePopup] = useState(false);
  const [openAddDriverPopup, setOpenAddDriverPopup] = useState(false);
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["runsheet"],
  });
  const { mutateAsync: addVehicle, isPostLoading: isVehicleLoading } =
    usePostHook({
      queryKey: ["vehicle"],
      navigateURL: "",
    });
  const { mutateAsync: addDriver, isPostLoading: isDriverLoading } =
    usePostHook({
      queryKey: ["riders"],
      navigateURL: "",
    });

  const handleAddDriver = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER_CREATE}`;
    let formData = {
      ...values,
      branch: profile?.default_branch?.id,
      username: values?.username ?? null,
      email: values?.email ?? null,
      mobile_number: `+977${values?.mobile_number}`,
    };
    try {
      const res = await addDriver({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddDriverPopup(!openAddDriverPopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleAddVehicle = async (values: any, setError: any) => {
    const url = `${APIS.VEHICLE}`;
    let formData = {
      ...values,
      emergency_contact_number: `+977${values?.emergency_contact_number}`,
      insurance_company_contact_number: `+977${values?.insurance_company_contact_number}`,
      samiti_contact_number: `+977${values?.samiti_contact_number}`,
    };
    try {
      const res = await addVehicle({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddVehiclePopup(!openAddVehiclePopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY}`;
    let formData = {
      ...values,
      type: "runsheet",
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 201) {
        console.log(res?.data);
        navigate(`/runsheet/edit/${res?.data?.id}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Runsheet
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <CreateDeliveryComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          handleAddVehicle={handleAddVehicle}
          isVehicleLoading={isVehicleLoading}
          handleAddDriver={handleAddDriver}
          isDriverLoading={isDriverLoading}
          defaultBranch={profile?.default_branch}
          openAddDriverPopup={openAddDriverPopup}
          openAddVehiclePopup={openAddVehiclePopup}
          setOpenAddDriverPopup={setOpenAddDriverPopup}
          setOpenAddVehiclePopup={setOpenAddVehiclePopup}
        />
      )}
    </>
  );
};
export default CreateDelivery;
